import { useCurrentAccount } from "@/hooks/useCurrentAccount";
import { PermissionEnum } from "@/utils/enums/PermissionEnum";
import { ModuleEnum } from "@/utils/enums/ModuleEnum";

import { AsideMenuItem } from "./AsideMenuItem";
import { AsideMenuItemWithSub } from "./AsideMenuItemWithSub";
import { Restrict } from "@/components/Restrict";

export function AsideMenuMain() {
	const { uf, ibgeCode, module } = useCurrentAccount();

	return (
		<>
			<AsideMenuItem
				to="/home"
				icon="/media/icons/duotune/general/gen001.svg"
				title="HOME"
				fontIcon="bi-app-indicator"
			/>
			{uf && !ibgeCode && module === ModuleEnum.ESUS_APS && (
				<Restrict permissions={[PermissionEnum.ESUS_VIEW_STATE_REPORTS]}>
					<AsideMenuItem
						to="/dashboard-estadual/geral"
						icon="/media/icons/duotune/graphs/gra005.svg"
						title="DASHBOARD"
						fontIcon="bi-app-indicator"
					/>
					<AsideMenuItem
						to="/dashboard-estadual/vigilancia-em-saude"
						icon="/media/icons/duotune/graphs/gra003.svg"
						title="VIGILÂNCIA EM SAÚDE"
						fontIcon="bi-app-indicator"
					/>
					<AsideMenuItem
						to="/dashboard-estadual/gestantes"
						icon="/media/icons/duotune/graphs/gra003.svg"
						title="GESTANTES"
						fontIcon="bi-app-indicator"
					/>
					<AsideMenuItem
						to="/dashboard-estadual/triplice-viral"
						icon="/media/icons/duotune/medicine/med007.svg"
						title="TRIPLICE VIRAL"
						fontIcon="bi-app-indicator"
					/>
				</Restrict>
			)}

			{uf && ibgeCode && module === ModuleEnum.ESUS_APS && (
				<>
					<Restrict permissions={[PermissionEnum.ESUS_VIEW_REPORTS]}>
						<AsideMenuItemWithSub
							to=""
							icon="/media/icons/duotune/files/fil003.svg"
							title="RELATÓRIOS"
							fontIcon="bi-app-indicator"
						>
							<AsideMenuItemWithSub
								to=""
								icon="/media/icons/duotune/coding/cod007.svg"
								title="GESTÃO DE CADASTROS E VISITAS"
								fontIcon="bi-app-indicator"
							>
								<Restrict permissions={[PermissionEnum.ESUS_VIEW_REPORTS]}>
									<AsideMenuItem
										to="/componente-vinculo/dashboard"
										icon="/media/icons/duotune/graphs/gra004.svg"
										title="DASHBOARD"
										fontIcon="bi-app-indicator"
									/>
								</Restrict>
								<Restrict
									permissions={[PermissionEnum.ESUS_VIEW_CITIZEN_MANAGEMENT]}
								>
									<AsideMenuItem
										to="/componente-vinculo/cadastros"
										icon="/media/icons/duotune/communication/com006.svg"
										title="CADASTROS"
										fontIcon="bi-app-indicator"
									/>
								</Restrict>
							</AsideMenuItemWithSub>
							<AsideMenuItemWithSub
								to=""
								icon="/media/icons/duotune/general/gen028.svg"
								title="ATENDIMENTOS INDIVIDUAIS"
								fontIcon="bi-app-indicator"
							>
								<AsideMenuItem
									to="/relatorios/atendimentos-individuais/dashboard-profissional"
									icon="/media/icons/duotune/graphs/gra004.svg"
									title="DASHBOARD"
									fontIcon="bi-app-indicator"
								/>
								<AsideMenuItem
									to="/relatorios/atendimentos-individuais/atendimentos"
									icon="/media/icons/duotune/files/fil003.svg"
									title="ATENDIMENTOS"
									fontIcon="bi-app-indicator"
								/>
							</AsideMenuItemWithSub>
							<AsideMenuItemWithSub
								to=""
								icon="/media/icons/duotune/general/scheduling.svg"
								title="AGENDAMENTOS"
								fontIcon="bi-app-indicator"
							>
								<AsideMenuItem
									to="/relatorios/agendamentos/calendario"
									icon="/media/icons/duotune/files/fil002.svg"
									title="CALENDÁRIO"
									fontIcon="bi-app-indicator"
								/>
							</AsideMenuItemWithSub>
							<AsideMenuItem
								to="/relatorios/vigilancia-em-saude"
								icon="/media/icons/duotune/general/binoculo.svg"
								title="VIGILÂNCIA EM SAÚDE"
								fontIcon="bi-app-indicator"
							/>
							<AsideMenuItem
								to="/relatorios/gestantes"
								icon="/media/icons/duotune/medicine/med008.svg"
								title="GESTANTES"
								fontIcon="bi-app-indicator"
							/>
							<AsideMenuItem
								to="/relatorios/triplice-viral"
								icon="/media/icons/duotune/medicine/med007.svg"
								title="TRIPLICE VIRAL"
								fontIcon="bi-app-indicator"
							/>
							<AsideMenuItem
								to="/relatorios/busca-ativa-vacinal"
								icon="/media/icons/duotune/files/fil024.svg"
								title="BUSCA ATIVA VACINAL"
								fontIcon="bi-app-indicator"
							/>
						</AsideMenuItemWithSub>
					</Restrict>

					<Restrict
						permissions={[
							PermissionEnum.ESUS_VIEW_INDICATORS,
							PermissionEnum.ESUS_VIEW_REPORTS,
						]}
					>
						<AsideMenuItemWithSub
							to=""
							icon="/media/icons/duotune/general/gen017.svg"
							title="COMPONENTES"
							fontIcon="bi-app-indicator"
						>
							<AsideMenuItemWithSub
								to=""
								icon="/media/icons/duotune/coding/cod007.svg"
								title="COMPONENTE VÍNCULO"
								fontIcon="bi-app-indicator"
							>
								<Restrict permissions={[PermissionEnum.ESUS_VIEW_REPORTS]}>
									<AsideMenuItem
										to="/acompanhamento-territorial/dashboard"
										icon="/media/icons/duotune/graphs/gra004.svg"
										title="DASHBOARD"
										fontIcon="bi-app-indicator"
									/>
								</Restrict>
								<Restrict permissions={[PermissionEnum.ESUS_VIEW_REPORTS]}>
									<AsideMenuItem
										to="/acompanhamento-territorial/cadastros"
										icon="/media/icons/duotune/communication/com006.svg"
										title="RELATÓRIO DE ACOMPANHAMENTO"
										fontIcon="bi-app-indicator"
									/>
								</Restrict>
							</AsideMenuItemWithSub>
							<AsideMenuItemWithSub
								to=""
								icon="/media/icons/duotune/general/gen026.svg"
								title="COMPONENTE QUALIDADE"
								fontIcon="bi-app-indicator"
							>
								<AsideMenuItem
									to="/componente-qualidade/indicador/esf/1/detalhes"
									icon="/media/icons/duotune/communication/com014.svg"
									title="CUIDADOS DA ESF"
									fontIcon="bi-app-indicator"
								/>
								<AsideMenuItem
									to="/componente-qualidade/indicador/esb/1/detalhes"
									icon="/media/icons/duotune/medicine/med009.svg"
									title="CUIDADOS DA ESB"
									fontIcon="bi-app-indicator"
								/>
								<AsideMenuItem
									to="/componente-qualidade/indicador/emulti/1/detalhes"
									icon="/media/icons/duotune/general/gen022.svg"
									title="CUIDADOS DA EMULTI"
									fontIcon="bi-app-indicator"
								/>
							</AsideMenuItemWithSub>
						</AsideMenuItemWithSub>
					</Restrict>
				</>
			)}

			{/* SIntegrada */}
			{uf && ibgeCode && module === ModuleEnum.SINTEGRADA && (
				<Restrict permissions={[PermissionEnum.SINTEGRADA_VIEW_REPORTS]}>
					<AsideMenuItem
						to="/sintegrada/relatorios/setor/recepcao"
						icon="/media/icons/duotune/general/door.svg"
						title="RECEPÇÃO"
						fontIcon="bi-app-indicator"
					/>
					<AsideMenuItem
						to="/sintegrada/relatorios/setor/classificacao-risco"
						icon="/media/icons/duotune/abstract/abs013.svg"
						title="CLASSIFICAÇÃO DE RISCO"
						fontIcon="bi-app-indicator"
					/>
					<AsideMenuItem
						to="/sintegrada/relatorios/setor/consultorio-medico"
						icon="/media/icons/duotune/general/homeHearth.svg"
						title="CONSULTÓRIO"
						fontIcon="bi-app-indicator"
					/>
					{/* Temporariamente oculto
					<AsideMenuItem
						to="/sintegrada/relatorios/setor/consultorio-especialidade"
						icon="/media/icons/duotune/general/gen003.svg"
						title="CONSULTÓRIO ESPECIALIDADE"
						fontIcon="bi-app-indicator"
					/>
					*/}
					<AsideMenuItem
						to="/sintegrada/relatorios/setor/hospitalizacao"
						icon="/media/icons/duotune/general/bad.svg"
						title="OBSERVAÇÃO, INTERNAMENTO E SALA VERMELHA"
						fontIcon="bi-app-indicator"
					/>
					<AsideMenuItem
						to="/sintegrada/relatorios/procedimento"
						icon="/media/icons/duotune/general/report.svg"
						title="EXAMES/PROCEDIMENTOS"
						fontIcon="bi-app-indicator"
					/>
					<AsideMenuItem
						to="/sintegrada/relatorios/consultorio"
						icon="/media/icons/duotune/general/report.svg"
						title="RELATÓRIO DE ATENDIMENTOS"
						fontIcon="bi-app-indicator"
					/>
					<AsideMenuItem
						to="/sintegrada/relatorios/alta"
						icon="/media/icons/duotune/general/report.svg"
						title="RELATÓRIO DE ALTA"
						fontIcon="bi-app-indicator"
					/>
					<AsideMenuItem
						to="/sintegrada/relatorios/ocupacao"
						icon="/media/icons/duotune/general/report.svg"
						title="RELATÓRIO DE OCUPAÇÃO"
						fontIcon="bi-app-indicator"
					/>
					<AsideMenuItem
						to="/sintegrada/relatorios/hipotese-diagnostica"
						icon="/media/icons/duotune/general/report.svg"
						title="RELATÓRIO DE HIPÓTESE DIAGNÓSTICA"
						fontIcon="bi-app-indicator"
					/>
					<AsideMenuItem
						to="/sintegrada/relatorios/lista/notificacoes-de-agravos"
						icon="/media/icons/duotune/files/fil001.svg"
						title="NOTIFICAÇÕES DE AGRAVOS"
						fontIcon="bi-app-indicator"
					/>
					<div className="d-none">
						<Restrict>
							<AsideMenuItemWithSub
								to=""
								icon="/media/icons/duotune/abstract/abs013.svg"
								title="LISTAGEM"
								fontIcon="bi-app-indicator"
							>
								<AsideMenuItem
									to="/sintegrada/relatorios/lista/atendimentos"
									icon="/media/icons/duotune/abstract/abs013.svg"
									title="ATENDIMENTOS"
									fontIcon="bi-app-indicator"
								/>
								<AsideMenuItem
									to="/sintegrada/relatorios/lista/pacientes"
									icon="/media/icons/duotune/abstract/abs013.svg"
									title="PACIENTES"
									fontIcon="bi-app-indicator"
								/>
								<AsideMenuItem
									to="/sintegrada/relatorios/lista/evasoes"
									icon="/media/icons/duotune/abstract/abs013.svg"
									title="EVASOES"
									fontIcon="bi-app-indicator"
								/>
								<AsideMenuItem
									to="/sintegrada/relatorios/lista/procedimentos"
									icon="/media/icons/duotune/abstract/abs013.svg"
									title="EXAMES E PROCEDIMENTOS"
									fontIcon="bi-app-indicator"
								/>
								<AsideMenuItem
									to="/sintegrada/relatorios/lista/obitos"
									icon="/media/icons/duotune/abstract/abs013.svg"
									title="ÓBITOS"
									fontIcon="bi-app-indicator"
								/>
							</AsideMenuItemWithSub>
						</Restrict>
					</div>
				</Restrict>
			)}
			{/* SIntegrada */}

			<AsideMenuItemWithSub
				to=""
				icon="/media/icons/duotune/electronics/elc004.svg"
				title="AMBIENTE DE APOIO"
				fontIcon="bi-app-indicator"
			>
				<AsideMenuItem
					to="/ambiente-de-apoio/acesso-a-plataforma"
					icon="/media/icons/duotune/technology/teh003.svg"
					title="ACESSO A PLATAFORMA"
					fontIcon="bi-app-indicator"
				/>
			</AsideMenuItemWithSub>

			<Restrict
				permissions={[
					PermissionEnum.ESUS_VIEW_PROFESSIONAL_MANAGEMENT,
					PermissionEnum.ESUS_STATE_PROFESSIONAL_MANAGEMENT,
					PermissionEnum.SINTEGRADA_PROFESSIONAL_MANAGEMENT,
				]}
			>
				<AsideMenuItem
					to="/gestao-de-profissionais"
					icon="/media/icons/duotune/communication/com014.svg"
					title="GESTÃO DE USUÁRIOS"
					fontIcon="bi-app-indicator"
				/>
			</Restrict>

			<AsideMenuItem
				to="/versoes"
				icon="/media/icons/duotune/files/fil011.svg"
				title="VERSÕES"
				fontIcon="bi-app-indicator"
			/>

			<Restrict>
				<AsideMenuItemWithSub
					to=""
					icon="/media/icons/duotune/coding/cod009.svg"
					title="CONFIGURAÇÕES"
					fontIcon="bi-app-indicator"
				>
					<AsideMenuItem
						to="/configuracoes/banco-de-dados"
						icon="/media/icons/duotune/abstract/abs027.svg"
						title="BANCO DE DADOS"
						fontIcon="bi-app-indicator"
					/>
					<AsideMenuItem
						to="/configuracoes/cidades"
						icon="/media/icons/duotune/maps/map008.svg"
						title="GESTÃO DE CIDADES"
						fontIcon="bi-app-indicator"
					/>
					<AsideMenuItem
						to="/configuracoes/gestao-de-perfil"
						icon="/media/icons/duotune/general/gen049.svg"
						title="GESTÃO DE PERFIL"
						fontIcon="bi-app-indicator"
					/>
					<AsideMenuItem
						to="/configuracoes/track-lists"
						icon="/media/icons/duotune/social/soc007.svg"
						title="GESTÃO DE VIDEOS"
						fontIcon="bi-app-indicator"
					/>
					<AsideMenuItem
						to="/configuracoes/banners"
						icon="/media/icons/duotune/general/gen006.svg"
						title="GESTÃO DE BANNERS"
						fontIcon="bi-app-indicator"
					/>
				</AsideMenuItemWithSub>
			</Restrict>
		</>
	);
}
